import axios from "axios";
import { sisikong_url } from "..";

export interface CreateLoginRecordRequest {
  username: string;
  token?: string | null;
}

export interface CreateLoginRecordResponse {
  login_record_id: number;
  created: boolean;
  message: string;
}

/**
 * Create a login record for a user via Apollo B2B authentication endpoint.
 * Creates a new LoginRecord if:
 * - No record exists for this day
 * - A record exists but has a different token
 * Also updates the user's last_login field.
 */
export function createLoginRecord(
  data: CreateLoginRecordRequest,
  token: string,
): Promise<{ data: CreateLoginRecordResponse }> {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  data.token = token;
  return axios.post(`${sisikong_url}/crm/external/apollo-b2b/login-record`, data, { headers });
}
